<template>
  <div v-if="announcements.length > 0" class="announcement-bar">
    <div class="announcement-container">
      <div class="announcement-icon">
        <i class="el-icon-bell"></i>
      </div>
      <div class="announcement-content" 
           @mouseenter="pauseScroll" 
           @mouseleave="resumeScroll">
        <div class="announcement-scroll" 
             :class="{ 'paused': isPaused }"
             :style="{ animationDuration: scrollDuration + 's' }">
          <div class="announcement-list">
            <div class="announcement-item" 
                 v-for="announcement in displayAnnouncements" 
                 :key="announcement.id + '-' + announcement.copyIndex"
                 :class="getAnnouncementClass(announcement.type)">
              <span class="announcement-title">【{{ announcement.title }}】</span>
              <span class="announcement-text">{{ announcement.content }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 移除关闭按钮 - 滚动公告不允许被隐藏 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnouncementBar',
  data() {
    return {
      announcements: [],
      isPaused: false,
      scrollDuration: 30 // 滚动持续时间（秒）
    }
  },
  computed: {
    displayAnnouncements() {
      if (this.announcements.length === 0) return []
      
      // 为了实现无缝滚动，复制公告内容
      const duplicated = []
      
      // 添加两份公告内容，确保无缝滚动
      this.announcements.forEach((announcement, index) => {
        duplicated.push({ ...announcement, copyIndex: 0 })
      })
      this.announcements.forEach((announcement, index) => {
        duplicated.push({ ...announcement, copyIndex: 1 })
      })
      
      return duplicated
    }
  },
  async mounted() {
    console.log('AnnouncementBar 组件已挂载');
    await this.loadAnnouncements()
    console.log('公告加载完成:', {
      announcements: this.announcements.length,
      displayAnnouncements: this.displayAnnouncements.length
    });
  },
  methods: {
    async loadAnnouncements() {
      try {
        // 获取当前用户类型
        const userType = this.getUserType()
        console.log('正在加载公告，用户类型:', userType);
        
        const response = await this.$http.get(`/api/announcements/scroll?userType=${userType}`)
        console.log('公告API响应:', response);
        
        if (response && response.success) {
          this.announcements = response.data || []
          console.log('加载到的公告数量:', this.announcements.length);
          // 根据公告数量调整滚动速度
          this.adjustScrollSpeed()
        } else {
          console.log('公告API响应失败:', response);
        }
      } catch (error) {
        console.error('加载公告失败:', error)
      }
    },

    getUserType() {
      const currentPath = this.$route.path
      if (currentPath.startsWith('/admin')) {
        return 'admin'
      } else if (currentPath.startsWith('/worker')) {
        return 'worker'
      } else {
        return 'customer'
      }
    },

    getAnnouncementClass(type) {
      return `announcement-${type}`
    },

    pauseScroll() {
      this.isPaused = true
    },

    resumeScroll() {
      this.isPaused = false
    },

    // 移除隐藏相关方法 - 滚动公告不允许被隐藏

    adjustScrollSpeed() {
      // 根据公告数量和长度调整滚动速度
      const totalLength = this.announcements.reduce((total, announcement) => {
        return total + (announcement.title + announcement.content).length
      }, 0)
      
      // 基础速度：每个字符0.5秒
      const baseSpeed = Math.max(20, totalLength * 0.3)
      this.scrollDuration = baseSpeed
    }
  }
}
</script>

<style scoped>
.announcement-bar {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.announcement-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  min-height: 50px;
}

.announcement-icon {
  font-size: 18px;
  margin-right: 12px;
  flex-shrink: 0;
  animation: bell-shake 2s ease-in-out infinite;
}

@keyframes bell-shake {
  0%, 50%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(-10deg); }
  20%, 40% { transform: rotate(10deg); }
}

.announcement-content {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 30px;
  line-height: 30px;
  mask: linear-gradient(90deg, transparent, white 5%, white 95%, transparent);
  -webkit-mask: linear-gradient(90deg, transparent, white 5%, white 95%, transparent);
}

.announcement-scroll {
  animation: seamless-scroll 30s linear infinite;
  white-space: nowrap;
}

.announcement-scroll.paused {
  animation-play-state: paused;
}

.announcement-list {
  display: inline-flex;
  white-space: nowrap;
}

.announcement-item {
  margin-right: 100px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  min-width: max-content;
}

.announcement-title {
  font-weight: bold;
  margin-right: 10px;
  color: #FFE4B5;
}

.announcement-text {
  opacity: 0.95;
  font-size: 14px;
}

/* 移除关闭按钮样式 - 滚动公告不允许被隐藏 */

/* 公告类型样式 */
.announcement-info .announcement-title {
  color: #E3F2FD;
}

.announcement-warning .announcement-title {
  color: #FFF3CD;
}

.announcement-success .announcement-title {
  color: #D4F8D4;
}

.announcement-error .announcement-title {
  color: #FFE6E6;
}

/* 无缝滚动动画 */
@keyframes seamless-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .announcement-container {
    padding: 8px 15px;
    min-height: 45px;
  }

  .announcement-icon {
    font-size: 16px;
    margin-right: 8px;
  }

  .announcement-content {
    height: 26px;
    line-height: 26px;
  }

  .announcement-title {
    font-size: 13px;
  }

  .announcement-text {
    font-size: 12px;
  }

  .announcement-item {
    margin-right: 80px;
  }
}

@media (max-width: 480px) {
  .announcement-container {
    padding: 6px 10px;
    min-height: 40px;
  }

  .announcement-content {
    height: 24px;
    line-height: 24px;
  }

  .announcement-title {
    font-size: 12px;
    margin-right: 6px;
  }

  .announcement-text {
    font-size: 11px;
  }

  .announcement-item {
    margin-right: 60px;
  }

  /* 移除关闭按钮移动端样式 */
}

/* 进入和离开动画 */
.announcement-bar {
  transition: all 0.3s ease;
}

.announcement-bar:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>